module.exports = __webpack_public_path__ + "static/img/mobile_example.eae41c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/mobile_example.jpg
// module id = Lk0w
// module chunks = 3